<template>
  <FormulateForm
    ref="form"
    :model="value"
    :errors="props.errors"
    :schema="fields"
    @input="$emit('input', $event)"
    @submit="$emit('submitForm', $event)"
  >
    <slot />
    <button v-if="externalSubmit" :class="{ hidden: externalSubmit }" ref="submitBtn"></button>
  </FormulateForm>
</template>

<script>
import { computed, ref } from '@vue/composition-api';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: false,
    },
    fields: {
      type: Array,
    },
    externalSubmit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const submitBtn = ref(null);
    const form = ref();
    const renderedInputs = computed(() =>
      form.value?.$children?.map(vnode => ({
        name: vnode.$attrs.name,
        el: vnode.$el,
        children: vnode.inputChildren,
      }))
    );

    const handleSubmit = function() {
      if (!!props.externalSubmit) {
        submitBtn.value.click();
      }
    };

    return {
      form,
      props,
      renderedInputs,
      handleSubmit,
      submitBtn,
    };
  },
};
</script>
